<template>
    <section class="featured-categories-wrap mt-0 mb-4">
        <div class="container">
            <h6 class="title text-center mt-4 mt-lg-0">{{ data.title }}</h6>
            <p class="excerpt text-center mb-2 mb-xl-3">{{ data.subtitle }}</p>
            <div
                class="featured-categories-header mb-4 justify-content-center"
                v-if="data.title"
            >

                <ul class="tabs featured-categories-tabs mt-2">
                    <li
                        v-for="(tab, index) in tabs"
                        :key="index"
                        :class="classes(tab)"
                        :style="{ height: '50px' }"
                        @click="change(tab)"
                    >
                        <span class="featured-category-name">{{ tab.label }}</span>
                    </li>
                </ul>
            </div>

            <div class="tab-content featured-category-products">
                <ProductCard
                    v-for="product in products"
                    :key="product.id"
                    :product="product"
                />
            </div>
        </div>

        <dynamic-tab
            v-for="(category, index) in data.categories"
            :key="index"
            :label="category.name"
            :initial-logo="category.logo"
            :url="route('storefront.additional_products.index', { categoryNumber: index + 1 })"
        >
        </dynamic-tab>
    </section>
</template>

<style>
.tab-item {
    height: 50px;
}

/* .featured-category-products>.slick-dots {
    padding-top: 2rem !important;
} */

.additional_products {
    width: 600px;
}

@media screen and (max-width: 1300px) {
    .additional_products {
        width: 400px;
    }
}

@media screen and (max-width: 1051px) {
    .additional_products {
        width: 200px;
    }
}

@media screen and (max-width: 991px) {
    .additional_products {
        width: 100%;
    }
}
</style>

<script>
import ProductCard from '../../ProductCard.vue';
import DynamicTabsMixin from '../../../mixins/DynamicTabsMixin';
import { slickPrevArrow, slickNextArrow } from '../../../functions';

export default {
    components: { ProductCard },

    mixins: [
        DynamicTabsMixin,
    ],

    props: ['data'],

    methods: {
        selector() {
            return $('.featured-category-products');
        },

        slickOptions() {
            return {
                rows: 0,
                dots: true,
                centerMode: false,
                arrows: false,
                infinite: true,
                swipeToSlide: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                rtl: window.FleetCart.rtl,
                prevArrow: slickPrevArrow(),
                nextArrow: slickNextArrow(),
                responsive: [
                    {
                        breakpoint: 1761,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 1301,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 1051,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        },
                    },
                    {
                        breakpoint: 881,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        },
                    },
                    {
                        breakpoint: 641,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                ],
            };
        },
    },
};
</script>
